import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiCall from "../utils/apicall";
import { showSuccessToast, showErrorToast } from '../utils/Toast';

export const getSequence = createAsyncThunk(
  "getSequence/Sequence",
  async (ThunkApi) => {
    try {
      const res = await ApiCall.get("/sequences/get-all-sequence");
      //   console.log(res, "+++++");
      return res.data.data.sequence;
    } catch (error) {
      console.log(error);
      return ThunkApi.rejectWithValue(error.message);
    }
  }
);

export const createSequence = createAsyncThunk(
  "createSequence/Sequence",
  async (data, ThunkApi) => {
    try {
      const fData = new FormData();
      fData.append("sequence_name", data.sequence_name);
      fData.append("job_id", data.job_id);

      const res = await ApiCall.post("/sequences/createsequence", fData);
      if (res.data.success) {
        return res.data.data.createsequence;
      } else {
        return ThunkApi.rejectWithValue(res.data.message);
      }
    } catch (error) {
      console.log(error);
      return ThunkApi.rejectWithValue(error.message);
    }
  }
);

export const deletesequence = createAsyncThunk(
  "deleteSequence/Sequence",
  async (data, ThunkApi) => {
    try {
      const res = await ApiCall.delete(`/sequences/deletesequence/${data}`);
      if (res.data.success) {
        return data;
      }
    } catch (error) {
      console.log(error);
      return ThunkApi.rejectWithValue(error.message);
    }
  }
);

export const updateSequence = createAsyncThunk(
  "updateSequence/Sequence",
  async (data, ThunkApi) => {
    try {
      const fData = new FormData();
      fData.append("sequence_name", data.sequence_name);
      fData.append("job_id", data.job_id);

      const res = await ApiCall.put(
        `/sequences/update-sequence/${data.id}`,
        fData
      );
      if (res.data.success) {
        return res.data.data.updatesequence;
      } else {
        return ThunkApi.rejectWithValue(res.data.message);
      }
    } catch (error) {
      console.log(error);
      return ThunkApi.rejectWithValue(error.message);
    }
  }
);
export const createSequencetask = createAsyncThunk(
  "createSequencetask/SequenceTask",
  async (data, ThunkApi) => {
    try {
      const fData = new FormData();
      fData.append("sequence_id", data.sequence_id);
      fData.append("task_id", data.task_id);
      const res = await ApiCall.post(
        "/sequencestask/updatesequencetask",
        fData
      );

      if (res.data.success) {
        // console.log("REsponse", res.data);
        return res.data;
      } else {
        return ThunkApi.rejectWithValue(res.data.message);
      }
    } catch (error) {
      console.log(error);
      return ThunkApi.rejectWithValue(error.message);
    }
  }
);
export const deletesequencetask = createAsyncThunk(
  "deleteSequencetask/Sequencetask",
  async (data, ThunkApi) => {
    try {
      const res = await ApiCall.delete(
        `/sequencestask/delete-sequence-task/${data}`
      );
      if (res.data.success) {
        return data;
      }
    } catch (error) {
      console.log(error);
      return ThunkApi.rejectWithValue(error.message);
    }
  }
);

export const sequenceSlice = createSlice({
  name: "sequence",
  initialState: {
    sequence: [],
    isSequenceLoading: false,
    isSuccess: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getSequence.pending, (state, action) => {
      state.isSequenceLoading = true;
      state.isSuccess = false;
    });
    builder.addCase(getSequence.fulfilled, (state, action) => {
      if (action.payload) {
        state.sequence = action.payload;
      }
      state.isSequenceLoading = false;
      state.isSuccess = true;
    });
    builder.addCase(getSequence.rejected, (state, action) => {
      state.isSequenceLoading = false;
      state.isSuccess = false;
          showErrorToast('Failed to load processes. Please refresh.');
    });
    // ------------------ Delete Sequence -------------

    builder.addCase(deletesequence.pending, (state, action) => {
      // console.log('in extra pending')
      state.isSequenceLoading = true;
    });
    builder.addCase(deletesequence.fulfilled, (state, action) => {
      state.sequence = state.sequence.filter(
        (inv) => inv.id !== action.payload
      );
      state.isSequenceLoading = false;
          showSuccessToast('Process deleted successfully.');
    });
    builder.addCase(deletesequence.rejected, (state, action) => {
      state.isSequenceLoading = false;
          showErrorToast('Failed to delete process. Please try again.');
    });
    // ------------------ Delete Sequence Task -------------

    builder.addCase(deletesequencetask.pending, (state, action) => {
      // console.log('in extra pending')
      state.isSequenceLoading = true;
    });
    builder.addCase(deletesequencetask.fulfilled, (state, action) => {
      state.sequence = state.sequence.filter(
        (inv) => inv.id !== action.payload
      );
      state.isSequenceLoading = false;
          showSuccessToast('Process task deleted successfully.');
    });
    builder.addCase(deletesequencetask.rejected, (state, action) => {
      state.isSequenceLoading = false;
    });

    // ------------- Create Sequence ----------------

    builder.addCase(createSequence.pending, (state, action) => {
      // console.log('in extra add pending')
      state.isSequenceLoading = true;
    });
    builder.addCase(createSequence.fulfilled, (state, action) => {
      if (action.payload) state.sequence.unshift(action.payload);
      state.isSequenceLoading = false;
          showSuccessToast('Process created successfully.');
    });
    builder.addCase(createSequence.rejected, (state, action) => {
      state.isSequenceLoading = false;
          showErrorToast('Failed to create process. Please try again.');
    });

    // ------------- Create SequenceTask ----------------
    builder.addCase(createSequencetask.pending, (state, action) => {
      // console.log('in extra add pending')
      state.isSequenceLoading = true;
    });
    builder.addCase(createSequencetask.fulfilled, (state, action) => {
      // console.log(action.payload, "payload");
      if (action.payload) state.sequence.unshift(action.payload.data);
      state.isSequenceLoading = false;
          showSuccessToast('Process task created successfully.');
    });
    builder.addCase(createSequencetask.rejected, (state, action) => {
      state.isSequenceLoading = false;
    });

    // ------------- Update Sequence ----------------

    builder.addCase(updateSequence.pending, (state, action) => {
      state.isSequenceLoading = true;
    });
    builder.addCase(updateSequence.fulfilled, (state, action) => {
      const updatedSequence = action.payload;
      state.sequence = state.sequence.map((inv) => {
        if (inv.id === updatedSequence.id) {
          return updatedSequence;
        }
        return inv;
      });
      state.isSequenceLoading = false;
          showSuccessToast('Process updated successfully.');
    });
    builder.addCase(updateSequence.rejected, (state, action) => {
      state.isSequenceLoading = false;
          showErrorToast('Failed to update process. Please try again.');
    });
  },
});

export default sequenceSlice.reducer;
